import { render } from "./g-navbar.vue?vue&type=template&id=0daf2d2a&scoped=true"
import script from "./g-navbar.vue?vue&type=script&lang=js"
export * from "./g-navbar.vue?vue&type=script&lang=js"

import "./g-navbar.vue?vue&type=style&index=0&id=0daf2d2a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0daf2d2a"]])

export default __exports__